module.exports = __webpack_public_path__ + "media/waiting-room-9.cf0d7a55.mp4";